import type { IconSvgObject } from './types';

const BloodTypeIcon: IconSvgObject = [
  ["path", { d: "M11.5063 2.31086C11.8101 2.11217 12.1899 2.11217 12.4937 2.31086C14.3078 3.49703 20.5 7.95215 20.5 13.5C20.5 18.1944 16.6944 22 12 22C7.30558 22 3.5 18.1944 3.5 13.5C3.5 7.95215 9.69216 3.49703 11.5063 2.31086Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M9 16L11.5 10H12.5L13.9583 13.5M15 16L13.9583 13.5M10.0417 13.5H13.9583", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default BloodTypeIcon;
